var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncBooking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.778,
    height: 30.777,
    viewBox: "0 0 30.778 30.777",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "date_6138397",
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1327",
    "data-name": "Path 1327",
    d: "M29.567,2.943H25.9V1.233a.733.733,0,1,0-1.466,0v1.71H22.972V1.233a.733.733,0,1,0-1.466,0v1.71H10.27V1.233a.733.733,0,0,0-1.466,0v1.71H7.339V1.233a.733.733,0,1,0-1.466,0v1.71H2.21A1.712,1.712,0,0,0,.5,4.652V29.567a1.712,1.712,0,0,0,1.71,1.71h17.1a.733.733,0,1,0,0-1.466H2.21a.245.245,0,0,1-.244-.244v-19.3H29.812v4.152a.733.733,0,0,0,1.466,0V4.652A1.712,1.712,0,0,0,29.567,2.943Zm-27.6,1.71a.245.245,0,0,1,.244-.244H5.874v1.71a.733.733,0,0,0,1.466,0V4.408H8.8v1.71a.733.733,0,0,0,1.466,0V4.408H21.507v1.71a.733.733,0,1,0,1.466,0V4.408h1.466v1.71a.733.733,0,0,0,1.466,0V4.408h3.664a.245.245,0,0,1,.244.244V8.8H1.965Z",
    transform: "translate(0 0)",
    fill: "#694be7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1328",
    "data-name": "Path 1328",
    d: "M9.646,30.613a.733.733,0,0,0,.518.215l.052,0a.732.732,0,0,0,.534-.291l4.4-5.862a.733.733,0,0,0-1.173-.879l-3.89,5.186L7.751,26.646a.733.733,0,0,0-1.036,1.036Z",
    transform: "translate(-3.069 -11.764)",
    fill: "#694be7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1329",
    "data-name": "Path 1329",
    d: "M41.957,23.5H30.233a.733.733,0,0,0,0,1.466H41.957a.733.733,0,0,0,0-1.466Z",
    transform: "translate(-14.833 -11.764)",
    fill: "#694be7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1330",
    "data-name": "Path 1330",
    d: "M7.233,43.966h8.3a.733.733,0,1,0,0-1.466h-8.3a.733.733,0,0,0,0,1.466Z",
    transform: "translate(-3.069 -21.482)",
    fill: "#694be7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1331",
    "data-name": "Path 1331",
    d: "M7.233,49.966h9.282a.733.733,0,1,0,0-1.466H7.233a.733.733,0,0,0,0,1.466Z",
    transform: "translate(-3.069 -24.551)",
    fill: "#694be7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1332",
    "data-name": "Path 1332",
    d: "M7.233,55.966H19.446a.733.733,0,1,0,0-1.466H7.233a.733.733,0,0,0,0,1.466Z",
    transform: "translate(-3.069 -27.619)",
    fill: "#694be7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_269",
    "data-name": "Group 269",
    transform: "translate(15.156 15.156)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1333",
    "data-name": "Path 1333",
    d: "M38.04,42.261l7.281-6.812A2.582,2.582,0,1,0,41.672,31.8l-1.48,1.582a.729.729,0,0,0-.147-.089l-6.14-2.729a.732.732,0,0,0-.816.151l-.657.657a.733.733,0,0,0,0,1.036l4.434,4.435c.016.016.037.022.054.036l-2.061,2.2-2.63-1.315a.734.734,0,0,0-.846.137l-.67.67a.733.733,0,0,0,0,1.036l6.8,6.8a.733.733,0,0,0,1.036,0l.669-.67a.733.733,0,0,0,.137-.846Z",
    transform: "translate(-30.5 -30.5)",
    fill: "#694be7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1334",
    "data-name": "Path 1334",
    d: "M57.473,50.919l-2.381-5.358L51.839,48.6l3.789,3.789a.733.733,0,0,0,1.036,0l.657-.657A.732.732,0,0,0,57.473,50.919Z",
    transform: "translate(-41.414 -38.203)",
    fill: "#694be7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncBooking);
export default __webpack_public_path__ + "static/media/inc-booking.605b5e36dc3728a5539e1efb543fdc26.svg";
export { ForwardRef as ReactComponent };